import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useAppSelector from "@/core/helpers/useAppSelector";
import { Modal, SoundButton } from "@/shared/ui";
import { activeSessionsSelector } from "@/domains/account/slice";
import useActiveSessions from "@/domains/playerMenu/hooks/useActiveSessions";
import PlayerMenuSettingsSafetyCloseSession from "@/domains/playerMenu/components/settings/safety/closeActiveSessions/PlayerMenuSettingsSafetyCloseSession";

type Props = {
  onClose: () => void;
};

export default function PlayerMenuSettingsSafetyCloseSessionsContainer({ onClose }: Props) {
  const { t } = useTranslation("account");
  const {
    closeSessions,
    closeSessionsIsPending,
    getSessions,
    getSessionsIsPending,
    closeSessionsIsCompleted,
  } = useActiveSessions();
  const activeSessions = useAppSelector(activeSessionsSelector);

  useEffect(() => {
    getSessions();
  }, []);

  const onConfirmHandler = useCallback(async () => {
    await closeSessions();
  }, [closeSessions]);

  useEffect(() => {
    if (closeSessionsIsCompleted) {
      onClose();
    }
  }, [closeSessionsIsCompleted]);

  const footer = (
    <div className="w-full grid grid-cols-2 items-center gap-2">
      <SoundButton
        onClick={onConfirmHandler}
        disabled={closeSessionsIsPending || getSessionsIsPending}
        loading={closeSessionsIsPending}
      >
        {t("account.yes")}
      </SoundButton>
      <SoundButton
        variant="solid-surface-gradient"
        onClick={onClose}
        disabled={closeSessionsIsPending || getSessionsIsPending}
      >
        {t("account.no")}
      </SoundButton>
    </div>
  );

  return (
    <Modal
      open
      onClose={onClose}
      className="w-[24rem] z-2"
      footer={footer}
      title={t("account.closeAllSession")}
    >
      {getSessionsIsPending ? (
        <div className="flex items-center justify-center p-4">
          <div className="mz-loader" />
        </div>
      ) : (
        <PlayerMenuSettingsSafetyCloseSession sessions={activeSessions} />
      )}
    </Modal>
  );
}
